<template>
  <div class="HomePrivacy">
  <home-header></home-header>
  <!-- 隐私政策 -->
   <div class="main">
    <div class="maincontent">
      <p class="title">{{ $t("homePrivacy.text1")}}</p>
      <div class="textlayout">
        <div class="text">
            <p>{{ $t("homePrivacy.text2")}}</p>
            
            <div v-for="(item,index) in textcontent" 
            class="text"
            :key ="'text'+index">
            <p><strong>{{ item.strong }}</strong>{{ item.text }}</p>

            </div>
            <p>{{ $t("homePrivacy.text13")}}<a href="mailto:info@blacklocustcap.com">{{ $t("homePrivacy.text14")}}</a></p>
        </div>
      </div>
    </div>
   </div>
    
  <div class="footer"></div>
  </div>
</template>
<script>
import HomeHeader from './homecomponents/HomeHeader.vue';
export default {
  name: "HomePrivacy",
  components: {HomeHeader},
  data() {
    return {
      textcontent:[]
    };
  },
  computed: {},
  created() 
  {
    this.updateData(); 
  },
  methods: {
  updateData()
      {
        this.textcontent = [
        {
          strong: this.$t('homePrivacy.text3'),
          text: this.$t('homePrivacy.text4')
        },
        {
          strong: this.$t('homePrivacy.text5'),
          text: this.$t('homePrivacy.text6')
        },
        {
          strong: this.$t('homePrivacy.text7'),
          text: this.$t('homePrivacy.text8')
        },
        {
          strong: this.$t('homePrivacy.text9'),
          text: this.$t('homePrivacy.text10')
        },
        {
          strong: this.$t('homePrivacy.text11'),
          text: this.$t('homePrivacy.text12')
        },
        ];
    },
  },
  watch: {
    '$i18n.locale'() {
      this.updateData();
    }
  }
};

</script>
<style lang="scss" scoped>
.HomePrivacy
{
  color: #000;
  width: 100%;
}

.main
{
  display: flex;
  justify-content: center;
}

.textlayout
{
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  font-family: "OPPO-B";
  color: #000;
  font-size: 36px;
  text-align: center;
  margin-bottom: 20px;
}

.maincontent{
  max-width: 1200px;
  color: #606266;
  font-family: "OPPO-R";
  font-size: 20px;
  line-height: 27px;
  margin-top: 80px;
  width: 100%;
  p
  {
    margin-top: 17px;
  }
  .text
  {
    width: 1200px;
    margin-top: 40px;
  }
  a {
  font-weight: 600;
  color: #007BFF;
  text-decoration: none;
  }
  strong
  {
    color: #000;
    font-family: "OPPO-M";
  }
}

.footer
{
  margin-top: 120px;
}

@media (max-width: 768px) {
.textlayout
{
  display: flex;
  flex-direction: column;
}

.maincontent{
  width: 90%;
  color: #606266;
  font-family: "OPPO-R";
  font-size: 17px;
  line-height: 27px;
  margin-top: 40px;
  p
  {
  margin-top: 17px;
  }
  .text
  {
  width: 100%;
  }

}
.footer
{
margin-top: 40px;
}
}
</style>